import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { FirmService } from 'services';

const firmService = new FirmService();

type ExportDailyNavParams = {
  firmId: number;
  date?: string | null;
  filename: string;
};

const useExportDailyNav = () => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async ({ firmId, date, filename }: ExportDailyNavParams) => {
      // Read as a blob here rather than through the generated service, which
      // types a file response as `any`.
      const blob = await firmService.exportDailyNav(firmId, date);
      const objectUrl = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = objectUrl;
      anchor.download = filename;
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
    },
    onError: error => {
      const message =
        (error as { status?: number })?.status === 404
          ? 'There are no Daily NAV records to export for this date.'
          : 'Unable to export Daily NAV. Please try again later.';
      enqueueSnackbar(message, { variant: 'error' });
    },
  });
};

export default useExportDailyNav;
